module.exports = __webpack_public_path__ + "img/p3_7.eea1e299.png";